import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef, ViewChild, ViewChildren, QueryList, Output, EventEmitter } from "@angular/core";
import { delay, SharedService } from '../../../shared'
import { CannabisOption, THC_CBD_Group, PartnerNamesEnum } from '../../shared'
import { SplitComponent, SplitAreaDirective } from 'angular-split'

@Component({
    selector: 'dosage-app-popup',
    templateUrl: "./dosage-app-popup.component.html",
    styleUrls: ["./dosage-app-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DosageAppPopupComponent implements OnInit {
    @ViewChild(SplitComponent) splitEl: SplitComponent
    @ViewChildren(SplitAreaDirective) areasEl: QueryList<SplitAreaDirective>

    @Input() partnerName: string = "";
    @Input() selectedProductName: any;
    @Input() selectedProduct: any;
    @Input() secTwoQuestTwoOption: CannabisOption;
    @Input() secTwoQuestOneGroup: THC_CBD_Group;

    @Output() updateSecTwoQuestTwoOption = new EventEmitter<any>();

    PartnerNamesEnum = PartnerNamesEnum;

    mainOptionsList: CannabisOption[] = [];
    selectedMainOption: CannabisOption;

    optionsList: CannabisOption[];
    selectedOption: CannabisOption;
    dosageTextareaValue: string = "";

    defaultBtnText: string = "ggf. Dosisanpassung, ggf Wechsel der Route und des Produkts";

    defaultTab = "Übersicht";
    dosageTabs: string[] = [this.defaultTab];
    selectedTab: string = this.defaultTab;

    singleUsage: number = 0;

    perscriptionDaysStep: number = 5;
    perscriptionStep: number = 1;

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    get GroupTitle() {
        return (this.secTwoQuestOneGroup && this.secTwoQuestOneGroup.Title) ? this.secTwoQuestOneGroup.Title : "";
    }

    get isTHCCBDSelected() {
        return this.GroupTitle && this.GroupTitle.length > 0;
    }

    get IsTHC() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") > -1;
    }

    get IsDronabinol() {
        return this.GroupTitle && this.GroupTitle.indexOf("CBD") === -1;
    }

    get IsTHCAndCBD() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") > -1 && this.GroupTitle.indexOf("CBD") > -1;
    }

    get IsShowCannaibKapseln() {
        if (!this.partnerName || this.partnerName === PartnerNamesEnum.AVEXTRA) {
            return this.IsTHCAndCBD;
        }
        return false;
    }

    get thcEqality() {
        if (this.selectedProduct) {
            return this.selectedProduct.THC_Equality || "";
        }
        else if (this.secTwoQuestOneGroup && this.secTwoQuestOneGroup.THC) {
            return this.secTwoQuestOneGroup.THC.Equality || "";
        }
        else {
            return "";
        }
    }

    get cbdEquality() {
        if (this.selectedProduct) {
            return this.selectedProduct.CBD_Equality || "";
        }
        else if (this.secTwoQuestOneGroup && this.secTwoQuestOneGroup.CBD) {
            return this.secTwoQuestOneGroup.CBD.Equality || "";
        }
        else {
            return "";
        }
    }

    get $productTHC() {
        return jQuery("#productTHC");
    }
    get productTHC() {
        return (this.$productTHC.val() || 0) as number;
    }

    get $productCBD() {
        return jQuery("#productCBD");
    }
    get productCBD() {
        return (this.$productCBD.val() || 0) as number;
    }

    get $singleUsageTHC() {
        return jQuery("#singleUsageTHC");
    }
    get singleUsageTHC() {
        return (this.$singleUsageTHC.val() || 0) as number;
    }

    get $singleUsageCBD() {
        return jQuery("#singleUsageCBD");
    }
    get singleUsageCBD() {
        return (this.$singleUsageCBD.val() || 0) as number;
    }

    get $usagesPerDay() {
        return jQuery("#usagesPerDay");
    }
    get usagesPerDay() {
        return (this.$usagesPerDay.val() || 0) as number;
    }

    get $perscriptionDays() {
        return jQuery("#perscriptionDays");
    }
    get perscriptionDays() {
        return (this.$perscriptionDays.val() || 0) as number;
    }

    get $perscription() {
        return jQuery("#perscription");
    }
    get perscription() {
        return (this.$perscription.val() || 0) as number;
    }

    get $mgTHC() {
        return jQuery("#mgTHC");
    }

    get mgTHC() {
        return (this.$mgTHC.val() || 0) as number;
    }

    get $mgCBD() {
        return jQuery("#mgCBD");
    }

    get mgCBD() {
        return (this.$mgCBD.val() || 0) as number;
    }


    get jsPanelContentHeight() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
        }
        else {
            return document.body.clientHeight;
        }
    }

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        this.setMainOptions();
        this.fnSetOptionsBySecTwoQuestOne();
    }

    setMainOptions() {
        this.mainOptionsList = [];
        switch (this.partnerName) {
            case PartnerNamesEnum.ALTHEA:
                break;
            case PartnerNamesEnum.FOUR_20_PHARMA:
                if (this.IsDronabinol) {
                    this.mainOptionsList.push({ Label: "Cannabisblüten" });
                }
                break;
            default:
                this.mainOptionsList.push({ Label: "Cannabisblüten" });
                break;
        }
        this.mainOptionsList.push({ Label: "Cannabisextrakt" });

        switch (this.partnerName) {
            case PartnerNamesEnum.AVEXTRA:
                this.$perscriptionDays.val(25);
                this.perscriptionStep = 25;

                if (this.IsDronabinol || !this.isTHCCBDSelected) {
                    this.mainOptionsList.push({ Label: "Dronabinol" });
                }
                break;
            case PartnerNamesEnum.ALTHEA:
                break;
            case PartnerNamesEnum.BETAHEALTH:
            case PartnerNamesEnum.FOUR_20_PHARMA:
                break;
            default:
                {
                    if (!this.IsTHC || !this.isTHCCBDSelected) {
                        this.mainOptionsList.push({ Label: "Cannabidiol" });
                    }
                    if (this.IsDronabinol || !this.isTHCCBDSelected) {
                        this.mainOptionsList.push({ Label: "Dronabinol" });
                    }
                }
        }

        switch (this.partnerName) {
            case PartnerNamesEnum.ADREX:
            case PartnerNamesEnum.AVEXTRA:
            case PartnerNamesEnum.ALTHEA:
            case PartnerNamesEnum.BETAHEALTH:
            case PartnerNamesEnum.SWISS:
            case PartnerNamesEnum.FOUR_20_PHARMA:
                break;
            default:
                this.mainOptionsList.push({ Label: "Fertigarzneimittel" });
        }
    }

    fnChangeTab(tab: string) {
        this.selectedTab = tab;
    }

    fnInputSpinner() {
        this.cd.detectChanges();
        jQuery("input[data-type='input-spinner']").each((key, elm) => {
            if (jQuery(elm).is(":visible")) {
                const elmId = jQuery(elm).attr("id");
                jQuery(elm).inputSpinner();
            }
        })
    }

    formulaFunctions() {
        let component = this;
        this.fnInputSpinner();

        if (component.selectedMainOption.Label !== 'Cannabidiol') {
            component.$productTHC.val(5);
        }
        if (component.selectedMainOption.Label !== 'Dronabinol') {
            component.$productCBD.val(5);
        }
        component.singleUsage = 0.2;
        component.$usagesPerDay.val(3);

        switch (this.partnerName) {
            case PartnerNamesEnum.AVEXTRA:
                this.perscriptionStep = 25;
                this.$perscriptionDays.val(25);
                break;
            default:
                this.perscriptionStep = 1;
                this.$perscriptionDays.val(30);
        }

        if (!this.partnerName || this.partnerName === PartnerNamesEnum.AVEXTRA) {
            if (this.selectedOption.Label == "Cannabisextrakt-Kapseln") {
                this.$perscriptionDays.val(30);
                this.perscriptionStep = 60;
            }
        }

        if (!(component.selectedOption.Label === "Dronabinol-Kapseln" || component.selectedOption.Label === "Cannabis-Kapseln" || component.selectedOption.Label === "Cannabidiol-Kapseln")) {
            if (component.selectedMainOption.Label !== 'Cannabidiol') {
                component.$singleUsageTHC.val(5);
            }
            if (component.selectedMainOption.Label !== 'Dronabinol') {
                component.$singleUsageCBD.val(5);
            }
        }

        jQuery("#perscription").prop("disabled", false);
        jQuery("#mgTHC").prop("disabled", true);
        jQuery("#mgCBD").prop("disabled", true);

        if (this.selectedMainOption.Label === 'Cannabisblüten' || this.selectedMainOption.Label === 'Cannabisextrakt' || this.selectedMainOption.Label === "Fertigarzneimittel") {
            if (this.selectedProduct) {
                const THC = this.selectedProduct.THC || 0;
                const CBD = this.selectedProduct.CBD || 0;
                if (this.selectedMainOption.Label === 'Cannabisblüten' || this.selectedMainOption.Label === 'Cannabisextrakt' || component.selectedOption.Label === "Cannabis-Kapseln") {
                    this.$productTHC.val(THC);
                    this.$productCBD.val(CBD);
                } else {
                    this.$singleUsageTHC.val(THC);
                    this.$singleUsageCBD.val(CBD);
                }
            }
            else if (this.secTwoQuestOneGroup && this.secTwoQuestOneGroup.THC && this.secTwoQuestOneGroup.CBD) {
                const THC = this.secTwoQuestOneGroup.THC.Value || 0;
                const CBD = this.secTwoQuestOneGroup.CBD.Value || 0;
                if (this.selectedMainOption.Label === 'Cannabisblüten' || this.selectedMainOption.Label === 'Cannabisextrakt' || component.selectedOption.Label === "Cannabis-Kapseln") {
                    this.$productTHC.val(THC);
                    this.$productCBD.val(CBD);
                } else {
                    this.$singleUsageTHC.val(THC);
                    this.$singleUsageCBD.val(CBD);
                }
            }
        }

        if (this.selectedMainOption.Label === 'Cannabisblüten') {
            component.fnUpdateViaCannabisblüten([3, 2, 5]);
        }

        if (component.selectedMainOption.Label === "Cannabisextrakt" || component.selectedMainOption.Label === "Dronabinol" || component.selectedMainOption.Label === "Cannabidiol") {
            component.$usagesPerDay.val(2);

            if (component.selectedOption.Label === "Dronabinol-Kapseln" || component.selectedOption.Label === "Cannabidiol-Kapseln") {
                jQuery("#perscription").prop("disabled", true);
                if (component.selectedOption.Label === "Cannabidiol-Kapseln") {
                    component.fnUpdateViaCannabidiolKapseln([1, 2]);
                } else {
                    component.fnUpdateViaDronabinolKapseln([1, 2]);
                }
            } else {
                if (component.selectedOption.Label === 'Cannabisextrakt-Tropfen') {
                    component.fnUpdateViaCannibisextraktTropfen([3, 2, 5, 7]);
                } else if (component.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                    component.fnUpdateViaCannibisextraktKapseln([1, 2]);
                } else if (component.selectedOption.Label === "Ölige Cannabidiol-Tropfen") {
                    component.fnUpdateViaCannabidiol([2, 3, 5]);
                } else {
                    component.fnUpdateViaDronabinol([2, 3, 5]);
                }
            }

        }

        if (this.selectedMainOption.Label === 'Fertigarzneimittel') {
            component.$usagesPerDay.val(2);
            if (component.selectedOption.Label === "Cannabis-Kapseln") {
                jQuery("#perscription").prop("disabled", true);
                component.fnUpdateViaFertigarzneimittel([1]);
            } else {
                component.fnUpdateViaFertigarzneimittel([2]);
            }
        }


        this.updateDosageTextareaValue();
        this.fnInputChangeEvent();
    }

    fnInputChangeEvent() {
        let component = this;
        component.$productTHC.on("change", function (event) {
            if (component.selectedMainOption.Label === "Cannabisblüten") {
                component.fnUpdateViaCannabisblüten([3, 2, 5]);
            }
            if (component.selectedMainOption.Label === "Cannabisextrakt") {
                if (component.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                    component.fnUpdateViaCannibisextraktTropfen([3, 2, 5, 7]);
                } else if (component.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                    component.fnUpdateViaCannibisextraktKapseln([2]);
                }
            }
            if (component.selectedMainOption.Label === "Dronabinol") {
                if (component.selectedOption.Label === "Dronabinol-Kapseln") {
                    component.fnUpdateViaDronabinolKapseln([2]);
                }
                else {
                    component.fnUpdateViaDronabinol([2, 3, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Fertigarzneimittel") {
                if (component.selectedOption.Label === "Cannabis-Kapseln") {
                    component.fnUpdateViaFertigarzneimittel([]);
                } else {
                    component.fnUpdateViaFertigarzneimittel([2]);
                }
            }
        });

        component.$productCBD.on("change", function (event) {
            if (component.selectedMainOption.Label === "Cannabisblüten") {
                component.fnUpdateViaCannabisblüten([4, 1, 5]);
            }
            if (component.selectedMainOption.Label === "Cannabisextrakt") {
                if (component.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                    component.fnUpdateViaCannibisextraktTropfen([4, 1, 5, 7]);
                } else if (component.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                    component.fnUpdateViaCannibisextraktKapseln([2]);
                }
            }
            if (component.selectedMainOption.Label === "Cannabidiol") {
                if (component.selectedOption.Label === "Cannabidiol-Kapseln") {
                    component.fnUpdateViaCannabidiolKapseln([2]);
                }
                else {
                    component.fnUpdateViaCannabidiol([2, 3, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Fertigarzneimittel") {
                if (component.selectedOption.Label === "Cannabis-Kapseln") {
                    component.fnUpdateViaFertigarzneimittel([]);
                } else {
                    component.fnUpdateViaFertigarzneimittel([2]);
                }
            }
        });

        component.$singleUsageTHC.on("change", function (event) {
            if (component.selectedMainOption.Label === "Cannabisblüten") {
                component.fnUpdateViaCannabisblüten([3, 2, 5]);
            }
            if (component.selectedMainOption.Label === "Cannabisextrakt") {
                if (component.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                    component.fnUpdateViaCannibisextraktTropfen([3, 2, 5, 7]);
                } else if (component.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                    component.fnUpdateViaCannibisextraktKapseln([2]);
                }
            }
            if (component.selectedMainOption.Label === "Dronabinol") {
                if (component.selectedOption.Label === "Dronabinol-Kapseln") {
                    component.fnUpdateViaDronabinolKapseln([2]);
                }
                else {
                    component.fnUpdateViaDronabinol([2, 3, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Fertigarzneimittel") {
                if (component.selectedOption.Label === "Cannabis-Kapseln") {
                    component.fnUpdateViaFertigarzneimittel([]);
                } else {
                    component.fnUpdateViaFertigarzneimittel([2]);
                }
            }
        })

        component.$singleUsageCBD.on("change", function (event) {
            if (component.selectedMainOption.Label === "Cannabisblüten") {
                component.fnUpdateViaCannabisblüten([4, 1, 5]);
            }
            if (component.selectedMainOption.Label === "Cannabisextrakt") {
                if (component.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                    component.fnUpdateViaCannibisextraktTropfen([4, 1, 5, 7]);
                } else if (component.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                    component.fnUpdateViaCannibisextraktKapseln([2]);
                }
            }
            if (component.selectedMainOption.Label === "Cannabidiol") {
                if (component.selectedOption.Label === "Cannabidiol-Kapseln") {
                    component.fnUpdateViaCannabidiolKapseln([2]);
                }
                else {
                    component.fnUpdateViaCannabidiol([2, 3, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Fertigarzneimittel") {
                if (component.selectedOption.Label === "Cannabis-Kapseln") {
                    component.fnUpdateViaFertigarzneimittel([]);
                } else {
                    component.fnUpdateViaFertigarzneimittel([2]);
                }
            }
        })

        component.$usagesPerDay.on("change", function (event) {
            if (component.selectedMainOption.Label === "Cannabisblüten") {
                component.fnUpdateViaCannabisblüten([5]);
            }
            if (component.selectedMainOption.Label === "Cannabisextrakt") {
                if (component.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                    component.fnUpdateViaCannibisextraktTropfen([5, 7]);
                } else if (component.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                    component.fnUpdateViaCannibisextraktKapseln([1, 2]);
                }
            }
            if (component.selectedMainOption.Label === "Dronabinol") {
                if (component.selectedOption.Label === "Dronabinol-Kapseln") {
                    component.fnUpdateViaDronabinolKapseln([1, 2]);
                }
                else {
                    component.fnUpdateViaDronabinol([3, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Cannabidiol") {
                if (component.selectedOption.Label === "Cannabidiol-Kapseln") {
                    component.fnUpdateViaCannabidiolKapseln([1, 2]);
                }
                else {
                    component.fnUpdateViaCannabidiol([3, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Fertigarzneimittel") {
                if (component.selectedOption.Label === "Cannabis-Kapseln") {
                    component.fnUpdateViaFertigarzneimittel([1]);
                } else {
                    component.fnUpdateViaFertigarzneimittel([2]);
                }
            }
        })

        component.$perscriptionDays.on("change", function (event) {
            if (component.selectedMainOption.Label === "Cannabisblüten") {
                component.fnUpdateViaCannabisblüten([5]);
            }
            if (component.selectedMainOption.Label === "Cannabisextrakt") {
                if (component.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                    component.fnUpdateViaCannibisextraktTropfen([5, 7]);
                } else if (component.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                    component.fnUpdateViaCannibisextraktKapseln([1, 2]);
                }
            }
            if (component.selectedMainOption.Label === "Dronabinol") {
                if (component.selectedOption.Label === "Dronabinol-Kapseln") {
                    component.fnUpdateViaDronabinolKapseln([1, 2]);
                }
                else {
                    component.fnUpdateViaDronabinol([3, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Cannabidiol") {
                if (component.selectedOption.Label === "Cannabidiol-Kapseln") {
                    component.fnUpdateViaCannabidiolKapseln([1, 2]);
                }
                else {
                    component.fnUpdateViaCannabidiol([3, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Fertigarzneimittel") {
                if (component.selectedOption.Label === "Cannabis-Kapseln") {
                    component.fnUpdateViaFertigarzneimittel([1]);
                } else {
                    component.fnUpdateViaFertigarzneimittel([2]);
                }
            }
        })

        component.$perscription.on("change", function (event) {
            if (component.selectedMainOption.Label === "Cannabisblüten") {
                component.fnUpdateViaCannabisblüten([6, 1, 2]);
            }
            if (component.selectedMainOption.Label === "Cannabisextrakt") {
                if (component.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                    component.fnUpdateViaCannibisextraktTropfen([6, 1, 2, 7]);
                } else if (component.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                    component.fnUpdateViaCannibisextraktKapseln([2, 3]);
                }
            }
            if (component.selectedMainOption.Label === "Dronabinol") {
                if (component.selectedOption.Label === "Dronabinol-Kapseln") {
                    component.fnUpdateViaDronabinolKapseln([2]);
                }
                else {
                    component.fnUpdateViaDronabinol([4, 1, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Cannabidiol") {
                if (component.selectedOption.Label === "Cannabidiol-Kapseln") {
                    component.fnUpdateViaCannabidiolKapseln([2]);
                }
                else {
                    component.fnUpdateViaCannabidiol([4, 1, 5]);
                }
            }
            if (component.selectedMainOption.Label === "Fertigarzneimittel") {
                if (component.selectedOption.Label === "Cannabis-Kapseln") {
                    component.fnUpdateViaFertigarzneimittel([1]);
                } else {
                    component.fnUpdateViaFertigarzneimittel([2]);
                }
            }
        })
    }

    fnUpdatePerscription(val) {
        if (this.selectedMainOption.Label === 'Cannabisblüten') {
            val = Math.ceil(Number.parseFloat(val.toString()) / 1000);
        }
        switch (this.partnerName) {
            case PartnerNamesEnum.AVEXTRA:
                this.fnCalculatePerscription(val);
                break;
            default:
                this.$perscription.val(val);
        }

        if (!this.partnerName || this.partnerName === PartnerNamesEnum.AVEXTRA) {
            if (this.selectedOption.Label == "Cannabisextrakt-Kapseln") {
                this.fnCalculatePerscription(val);
            }
        }
    }

    fnCalculatePerscription(val) {
        let dval = val / this.perscriptionStep;
        let nval = parseInt(dval.toString()) * this.perscriptionStep;
        if (dval !== parseInt(dval.toString())) {
            nval += this.perscriptionStep;
        }
        this.$perscription.val(nval);
    }

    getPerscription() {
        if (this.selectedMainOption.Label === 'Cannabisblüten') {
            return this.perscription * 1000;
        } else {
            return this.perscription;
        }
    }

    fnUpdateViaCannabisblüten(orders) {
        let component = this;
        orders.forEach(order => {
            switch (order) {
                case 1:
                    component.$singleUsageTHC.val((component.productTHC * component.singleUsage) / 100);
                    break;
                case 2:
                    component.$singleUsageCBD.val((component.productCBD * component.singleUsage) / 100);
                    break;
                case 3:
                    component.singleUsage = (component.singleUsageTHC * 100) / component.productTHC;
                    break;
                case 4:
                    component.singleUsage = (component.singleUsageCBD * 100) / component.productCBD;
                    break;
                case 5:
                    component.fnUpdatePerscription(component.perscriptionDays * component.usagesPerDay * component.singleUsage)
                    break;
                case 6:
                    component.singleUsage = (component.getPerscription() / component.perscriptionDays) / component.usagesPerDay;
                    break;
            }
        })
        component.updateDosageTextareaValue();
    }

    fnUpdateViaCannibisextraktTropfen(orders) {
        let component = this;
        orders.forEach(order => {
            switch (order) {
                case 1:
                    component.$singleUsageTHC.val(component.productTHC * component.singleUsage);
                    break;
                case 2:
                    component.$singleUsageCBD.val(component.productCBD * component.singleUsage);
                    break;
                case 3:
                    component.singleUsage = component.singleUsageTHC / component.productTHC;
                    break;
                case 4:
                    component.singleUsage = component.singleUsageCBD / component.productCBD;
                    break;
                case 5:
                    component.fnUpdatePerscription(component.perscriptionDays * component.usagesPerDay * component.singleUsage)
                    break;
                case 6:
                    component.singleUsage = (component.getPerscription() / component.perscriptionDays) / component.usagesPerDay;
                    break;
                case 7:
                    component.$mgTHC.val(component.productTHC * component.getPerscription());
                    break;
            }
        })
        component.updateDosageTextareaValue();
    }

    fnUpdateViaCannibisextraktKapseln(orders) {
        let component = this;
        orders.forEach(order => {
            switch (order) {
                case 1:
                    component.fnUpdatePerscription(component.perscriptionDays * component.usagesPerDay);
                    break;
                case 2:
                    component.$mgTHC.val(component.productTHC * component.getPerscription());
                    break;
                case 3:
                    component.$perscriptionDays.val(component.getPerscription() / component.usagesPerDay);
                    break;
            }
        })
        component.updateDosageTextareaValue();
    }

    fnUpdateViaDronabinol(orders) {
        let component = this;
        orders.forEach(order => {
            switch (order) {
                case 1:
                    component.$singleUsageTHC.val(component.productTHC * component.singleUsage);
                    break;
                case 2:
                    component.singleUsage = component.singleUsageTHC / component.productTHC;
                    break;
                case 3:
                    component.fnUpdatePerscription(component.perscriptionDays * component.usagesPerDay * component.singleUsage)
                    break;
                case 4:
                    component.singleUsage = (component.getPerscription() / component.perscriptionDays) / component.usagesPerDay;
                    break;
                case 5:
                    component.$mgTHC.val(component.productTHC * component.getPerscription());
                    break;
            }
        })
        component.updateDosageTextareaValue();
    }

    fnUpdateViaDronabinolKapseln(orders) {
        let component = this;
        orders.forEach(order => {
            switch (order) {
                case 1:
                    component.fnUpdatePerscription(component.perscriptionDays * component.usagesPerDay);
                    break;
                case 2:
                    component.$mgTHC.val(component.productTHC * component.getPerscription());
                    break;
            }
        })
        component.updateDosageTextareaValue();
    }


    fnUpdateViaCannabidiol(orders) {
        let component = this;
        orders.forEach(order => {
            switch (order) {
                case 1:
                    component.$singleUsageCBD.val(component.productCBD * component.singleUsage);
                    break;
                case 2:
                    component.singleUsage = component.singleUsageCBD / component.productCBD;
                    break;
                case 3:
                    component.fnUpdatePerscription(component.perscriptionDays * component.usagesPerDay * component.singleUsage)
                    break;
                case 4:
                    component.singleUsage = (component.getPerscription() / component.perscriptionDays) / component.usagesPerDay;
                    break;
                case 5:
                    component.$mgCBD.val(component.productCBD * component.getPerscription());
                    break;
            }
        })
        component.updateDosageTextareaValue();
    }

    fnUpdateViaCannabidiolKapseln(orders) {
        let component = this;
        orders.forEach(order => {
            switch (order) {
                case 1:
                    component.fnUpdatePerscription(component.perscriptionDays * component.usagesPerDay);
                    break;
                case 2:
                    component.$mgCBD.val(component.productCBD * component.getPerscription());
                    break;
            }
        })
        component.updateDosageTextareaValue();
    }

    fnUpdateViaFertigarzneimittel(orders) {
        let component = this;
        orders.forEach(order => {
            switch (order) {
                case 1:
                    component.fnUpdatePerscription(component.perscriptionDays * component.usagesPerDay);
                    component.$mgTHC.val(component.productTHC * component.getPerscription());
                    break;
                case 2:
                    component.$mgTHC.val(component.singleUsageTHC * component.perscriptionDays * component.usagesPerDay);
                    break;
            }
        })
        component.updateDosageTextareaValue();
    }


    ////////////////////////////////////////////////////////

    get perscriptionUnit() {
        if (this.selectedMainOption.Label === 'Cannabisblüten') {
            return "Gramm";
        }
        if (this.selectedOption.Label === 'Cannabisextrakt-Tropfen' || this.selectedOption.Label === 'Ethanolische Dronabinol-Lösung'
            || this.selectedOption.Label === 'Ölige Dronabinol-Tropfen' || this.selectedOption.Label === 'Ölige Cannabidiol-Tropfen') {
            return "ml";
        }
        if (this.selectedOption.Label === 'Cannabisextrakt-Kapseln' || this.selectedOption.Label === 'Dronabinol-Kapseln'
            || this.selectedOption.Label === 'Cannabis-Kapseln' || this.selectedOption.Label === 'Cannabidiol-Kapseln') {
            return "Kapseln";
        }
        return "";
    }

    get mgTHCUnit() {
        if (this.selectedMainOption.Label === 'Cannabisextrakt' || this.selectedMainOption.Label === 'Fertigarzneimittel'
            || this.selectedMainOption.Label === 'Dronabinol' || this.selectedMainOption.Label === 'Cannabidiol') {
            return "mg";
        }
        return "";
    }

    get mgCBDUnit() {
        if (this.selectedMainOption.Label === 'Cannabidiol') {
            return "mg";
        }
        return "";
    }

    selectMainOption(option: CannabisOption) {
        if (this.selectedMainOption.Label === option.Label) {
            return;
        }
        this.selectedMainOption = {
            Label: option.Label,
            Code: option.Code
        };
        this.setSelectedOption();
    }

    selectOption(option: CannabisOption) {
        if (this.selectedOption.Label === option.Label) {
            return;
        }
        this.selectedOption = {
            Label: option.Label,
            Code: option.Code
        };
        this.formulaFunctions();
        this.fnUpdateSecTwoQuestionOneOption();
    }

    fnUpdateSecTwoQuestionOneOption() {
        let option: CannabisOption = { Label: "" };
        if (this.selectedMainOption.Label === 'Fertigarzneimittel') {
            if (this.selectedOption.Label === "Cannabis-Spray") {
                option = { Label: "Fertigarzneimittel Spray" };
            }
            if (this.selectedOption.Label === "Cannabis-Kapseln") {
                option = { Label: "Fertigarzneimittel Kapseln" };
            }
        }
        if (this.selectedMainOption.Label === 'Cannabisextrakt') {
            if (this.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                option = { Label: "Cannabisextrakt Tropfen" };
            } else if (this.selectedOption.Label === 'Cannabisextrakt-Kapseln') {
                option = { Label: "Cannabisextrakt Kapseln" };
            }
        }
        if (this.selectedMainOption.Label === 'Dronabinol') {
            if (this.selectedOption.Label === "Ethanolische Dronabinol-Lösung") {
                option = { Label: "Ethanolische Dronabinol Lösung" };
            }
            if (this.selectedOption.Label === "Dronabinol-Kapseln") {
                option = { Label: "Dronabinol Kapseln" };
            }
            if (this.selectedOption.Label === "Ölige Dronabinol-Tropfen") {
                option = { Label: "Ölige Dronabinol Tropfen" };
            }
        }
        if (this.selectedMainOption.Label === 'Cannabidiol') {
            if (this.selectedOption.Label === "Cannabidiol-Kapseln") {
                option = { Label: "Cannabidiol Kapseln" };
            }
            if (this.selectedOption.Label === "Ölige Cannabidiol-Tropfen") {
                option = { Label: "Ölige Cannabidiol Tropfen" };
            }
        }
        if (this.selectedMainOption.Label === 'Cannabisblüten') {
            if (this.selectedOption.Label === "Cannabisblüten Inhalation") {
                option = { Label: "Cannabisblüten Inhalativ" };
            }
            if (this.selectedOption.Label === "Cannabisblüten Tee") {
                option = { Label: "Cannabisblüten Tee" };
            }
        }
        this.updateSecTwoQuestTwoOption.emit(option);
    }

    fnSetOptionsBySecTwoQuestOne() {
        this.selectedMainOption = { Label: "" };
        this.selectedOption = { Label: "" };
        if (this.secTwoQuestTwoOption.Label === "Fertigarzneimittel Spray") {
            this.selectedMainOption = { Label: "Fertigarzneimittel" };
            this.selectedOption = { Label: "Cannabis-Spray" };
        }
        if (this.secTwoQuestTwoOption.Label === "Fertigarzneimittel Kapseln") {
            this.selectedMainOption = { Label: "Fertigarzneimittel" };
            this.selectedOption = { Label: "Cannabis-Kapseln" };
        }

        if (this.secTwoQuestTwoOption.Label === "Cannabisextrakt Tropfen") {
            this.selectedMainOption = { Label: "Cannabisextrakt" };
            this.selectedOption = { Label: "Cannabisextrakt-Tropfen" };
        }
        if (this.secTwoQuestTwoOption.Label === "Cannabisextrakt Kapseln") {
            this.selectedMainOption = { Label: "Cannabisextrakt" };
            this.selectedOption = { Label: "Cannabisextrakt-Kapseln" };
        }

        if (this.secTwoQuestTwoOption.Label === "Ethanolische Dronabinol Lösung") {
            this.selectedMainOption = { Label: "Dronabinol" };
            this.selectedOption = { Label: "Ethanolische Dronabinol-Lösung" };
        }
        if (this.secTwoQuestTwoOption.Label === "Dronabinol Kapseln") {
            this.selectedMainOption = { Label: "Dronabinol" };
            this.selectedOption = { Label: "Dronabinol-Kapseln" };
        }
        if (this.secTwoQuestTwoOption.Label === "Ölige Dronabinol Tropfen") {
            this.selectedMainOption = { Label: "Dronabinol" };
            this.selectedOption = { Label: "Ölige Dronabinol-Tropfen" };
        }

        if (this.secTwoQuestTwoOption.Label === "Cannabidiol Kapseln") {
            this.selectedMainOption = { Label: "Cannabidiol" };
            this.selectedOption = { Label: "Cannabidiol-Kapseln" };
        }
        if (this.secTwoQuestTwoOption.Label === "Ölige Cannabidiol Tropfen") {
            this.selectedMainOption = { Label: "Cannabidiol" };
            this.selectedOption = { Label: "Ölige Cannabidiol-Tropfen" };
        }

        if (this.secTwoQuestTwoOption.Label === "Cannabisblüten Inhalativ") {
            this.selectedMainOption = { Label: "Cannabisblüten" };
            this.selectedOption = { Label: "Cannabisblüten Inhalation" };
        }
        if (this.secTwoQuestTwoOption.Label === "Cannabisblüten Tee") {
            this.selectedMainOption = { Label: "Cannabisblüten" };
            this.selectedOption = { Label: "Cannabisblüten Tee" };
        }
        this.fnSetOptionsList();
        this.formulaFunctions();
    }

    fnSetOptionsList() {
        this.optionsList = [];
        if (this.selectedMainOption.Label === 'Fertigarzneimittel') {
            this.optionsList = [
                { Label: "Cannabis-Spray" },
                { Label: "Cannabis-Kapseln" }
            ];
        }
        if (this.selectedMainOption.Label === 'Cannabisextrakt') {
            if (this.IsShowCannaibKapseln) {
                this.optionsList.push({ Label: "Cannabisextrakt-Kapseln" });
            }
            this.optionsList.push({ Label: "Cannabisextrakt-Tropfen" });
        }
        if (this.selectedMainOption.Label === 'Dronabinol') {
            if (this.partnerName !== PartnerNamesEnum.AVEXTRA) {
                this.optionsList.push({ Label: "Ethanolische Dronabinol-Lösung" });
            }
            this.optionsList.push({ Label: "Dronabinol-Kapseln" });
            this.optionsList.push({ Label: "Ölige Dronabinol-Tropfen" });
        }
        if (this.selectedMainOption.Label === 'Cannabidiol') {
            this.optionsList = [
                { Label: "Cannabidiol-Kapseln" },
                { Label: "Ölige Cannabidiol-Tropfen" }
            ];
        }
        if (this.selectedMainOption.Label === 'Cannabisblüten') {
            this.optionsList.push({ Label: "Cannabisblüten Inhalation" });
            if (this.partnerName !== PartnerNamesEnum.AVEXTRA && this.partnerName !== PartnerNamesEnum.ALTHEA && this.partnerName !== PartnerNamesEnum.FOUR_20_PHARMA) {
                this.optionsList.push({ Label: "Cannabisblüten Tee" });
            }
        }
        this.selectedTab = this.defaultTab;
        if (this.selectedMainOption.Label) {
            if (!this.partnerName || this.partnerName === PartnerNamesEnum.AVEXTRA) {
                this.dosageTabs = [this.selectedMainOption.Label, this.defaultTab];
                this.selectedTab = this.selectedMainOption.Label;
            } else {
                this.dosageTabs = [this.defaultTab, this.selectedMainOption.Label];
            }
        } else {
            this.dosageTabs = [this.defaultTab];
        }
    }

    setSelectedOption() {
        this.selectedOption = { Label: "" };
        this.fnSetOptionsList();
        if (this.optionsList.length) {
            this.selectOption(this.optionsList[0]);
        } else {
            this.formulaFunctions();
        }
        this.cd.detectChanges();
    }

    updateDosageTextareaValue() {
        let value = "";
        if (this.selectedProductName) {
            value += `${this.selectedProductName}\n`
        }
        if (this.selectedMainOption.Label === 'Cannabisblüten') {
            value += `Form: Cannabisblüten\n`;
            value += `Menge: ${this.perscription} g im Monat\n`;

            if (this.selectedOption.Label === "Cannabisblüten Tee") {
                value += `Dosis: 1 x tägl. ${Number.parseFloat((this.singleUsage * this.usagesPerDay).toString()).toFixed(2)} mg in 0,5 l Wasser 15 min abkochen - ${this.usagesPerDay} x tgl. 150 ml trinken\n`;
                value += `NRF 22.14`;
            }
            if (this.selectedOption.Label === "Cannabisblüten Inhalation") {
                value += `Dosis: ${this.usagesPerDay} x tägl. ${Number.parseFloat(this.singleUsage.toString()).toFixed(2)} mg verdampfen und inhalieren\n`;
                value += `NRF 22.12 oder Abgabe unzerkleinerter Blüten`;
            }
        }

        if (this.selectedMainOption.Label === 'Cannabisextrakt' || this.selectedMainOption.Label === 'Dronabinol'
            || this.selectedMainOption.Label === 'Fertigarzneimittel' || this.selectedMainOption.Label === 'Cannabidiol') {
            var dText = "zur oralen Einnahme";
            if (this.selectedOption.Label === "Ethanolische Dronabinol-Lösung") {
                dText = "verdampfen und inhalieren";
            }
            const thc = `${this.thcEqality}${this.productTHC}`;
            const cbd = `${this.cbdEquality}${this.productCBD}`;
            if (this.selectedOption.Label === "Cannabisextrakt-Kapseln") {
                value += `Avextra Pharma GmbH, Avextra Kapsel ${thc}mg THC/ ${thc}mg CBD\n`;
                value += `Cannabisextrakt Avextra 10 % E (PZN 18663706) mit CBD und Isomalt in Zubereitung, Kapseln a  ${thc} mg THC und ${thc} mg CBD\n`;
            }
            if (this.selectedOption.Label === "Cannabisextrakt-Tropfen" || this.selectedOption.Label === "Ethanolische Dronabinol-Lösung"
                || this.selectedOption.Label === "Ölige Dronabinol-Tropfen" || this.selectedOption.Label === "Ölige Cannabidiol-Tropfen") {
                value += `Form: ${this.selectedOption.Label}\n`;
                value += `${Number.parseFloat(this.getPerscription().toString()).toFixed(2)} ${this.perscriptionUnit}, Gesamtmenge `;

                if (this.selectedMainOption.Label === 'Cannabidiol') {
                    value += `CBD: ${Number.parseFloat(this.mgCBD.toString()).toFixed(2)} ${this.mgCBDUnit}\n`;
                } else {
                    value += `THC: ${Number.parseFloat(this.mgTHC.toString()).toFixed(2)} ${this.mgTHCUnit}\n`;
                    value += `THC-Konzentration: ${thc} mg/ml\n`;
                }

                if (this.productCBD > 0) {
                    value += `CBD-Konzentration: ${cbd} mg/ml\n`;
                }

                value += `Dosis: ${this.usagesPerDay} x tägl. ${Number.parseFloat(this.singleUsage.toString()).toFixed(2)} ml ${dText}\n`
            }
            if (this.selectedOption.Label === "Dronabinol-Kapseln" || this.selectedOption.Label === "Cannabisextrakt-Kapseln"
                || this.selectedOption.Label === "Cannabis-Kapseln" || this.selectedOption.Label === "Cannabidiol-Kapseln") {
                if (this.selectedOption.Label === "Cannabis-Kapseln") {
                    value += `Form: ${this.selectedMainOption.Label} Kapseln\n`;
                } else {
                    value += `Form: ${this.selectedOption.Label}\n`;
                }

                value += `${Number.parseFloat(this.getPerscription().toString()).toFixed(2)} ${this.perscriptionUnit}, Gesamtmenge `;
                if (this.selectedMainOption.Label === 'Cannabidiol') {
                    value += `CBD: ${Number.parseFloat(this.mgCBD.toString()).toFixed(2)} ${this.mgCBDUnit}\n`;
                } else {
                    value += `THC: ${Number.parseFloat(this.mgTHC.toString()).toFixed(2)} ${this.mgTHCUnit}\n`;
                    value += `THC-Masse pro Kapseln: ${thc} mg\n`;
                }
                if (this.productCBD > 0) {
                    value += `CBD-Masse pro Kapseln: ${cbd} mg\n`;
                }

                value += `Dosis: ${this.usagesPerDay} x tägl. 1 Kapseln ${dText}\n`
            }
            if (this.selectedOption.Label === "Cannabisextrakt-Tropfen") {
                value += `NRF 22.11`;
            }
            if (this.selectedOption.Label === "Ethanolische Dronabinol-Lösung") {
                value += `NRF 22.16`;
            }
            if (this.selectedOption.Label === "Ölige Dronabinol-Tropfen") {
                value += `NRF 22.8`;
            }
            if (this.selectedOption.Label === "Ölige Cannabidiol-Tropfen") {
                value += `NRF 22.10`;
            }
            if (this.selectedOption.Label === "Dronabinol-Kapseln") {
                value += `NRF 22.7`;
            }
            if (this.selectedOption.Label === "Cannabis-Spray") {
                value += `Form: ${this.selectedMainOption.Label} Cannabis Spray\n`;

                value += `Gesamtmenge THC: ${Number.parseFloat(this.mgTHC.toString()).toFixed(2)} ${this.mgTHCUnit}\n`;

                const thcSingle = `${this.thcEqality}${this.singleUsageTHC} mg`;
                value += `THC-Konzentration Einzel Dosis: ${thcSingle}\n`;

                const cbdSingle = `${this.cbdEquality}${this.singleUsageCBD} mg`;
                if (this.singleUsageCBD > 0) {
                    value += `CBD-Konzentration Einzel Dosis: ${cbdSingle}\n`;
                }
                value += `Dosis: ${this.usagesPerDay} x tägl.`;
            }
        }
        this.dosageTextareaValue = value;
        this.cd.detectChanges();
    }

    hasDefaultText() {
        return this.dosageTextareaValue.indexOf(this.defaultBtnText) > -1 ? true : false;
    }

    fnAddDefaultText() {
        if (this.hasDefaultText()) {
            this.dosageTextareaValue = this.dosageTextareaValue.replace(this.defaultBtnText, "").trim();
        }
        else {
            this.dosageTextareaValue += `\n${this.defaultBtnText}`;
        }
    }

}
